/*
  Bean & Paw FAQ topic nav (premium #9): marks the topic being read with aria-current, so the
  sticky side nav shows where the reader is. The anchor links work without this script.
  Current topic = the last group whose top has passed the reading line; at the page bottom,
  the last group (short final groups can never reach the line).
*/
const LINE = 160; // px below the viewport top: the sticky header plus a little air

function initFaq(root) {
  const links = new Map(
    [...root.querySelectorAll('.bp-faq__nav a[href^="#"]')].map((a) => [a.getAttribute('href').slice(1), a])
  );
  const groups = [...root.querySelectorAll('.bp-faq__group')].filter((g) => links.has(g.id));
  if (!groups.length) return;

  let ticking = false;
  const mark = () => {
    ticking = false;
    const box = root.getBoundingClientRect();
    let current = null;
    if (box.top < innerHeight && box.bottom > 0) {
      const atBottom = innerHeight + scrollY >= document.documentElement.scrollHeight - 4;
      current = atBottom ? groups.at(-1) : groups.filter((g) => g.getBoundingClientRect().top <= LINE).at(-1) ?? groups[0];
    }
    for (const [id, a] of links) {
      if (current && id === current.id) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    }
  };
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(mark);
  };
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  mark();
}

document.querySelectorAll('.bp-faq').forEach(initFaq);
